/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { newAxiosInstance } from './baseRequest';

// this request client will redirect the user to a login url if their session has expired
// the url needs to configurable since notary and participant users have different concepts of being "logged in"
export const authenticatedRequest = (navigateToLoginUrl: () => void) => {
  const a = newAxiosInstance();
  a.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status === 401) {
        navigateToLoginUrl();
      }
      return Promise.reject(error);
    },
  );
  return a;
};
